// Adapted from Microsoft Elixir-Framework (MIT), v3.0.1164, aa6c10ab1882f8fa20c1da308e6c1fc6fe2fe5e9.
// Source: packages/fx/src/components/Editor/RichText/ElxRichTextEditor.tsx. Local adaptations: Bug 38755929.
import { styled } from '@fluentui/react';
import { ElxRichTextEditorBase } from './ElxRichTextEditor.base';
import { getStyles } from './ElxRichTextEditor.styles';
export const ElxRichTextEditor = styled(ElxRichTextEditorBase, getStyles);
